import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {
  url: string;
  subMenus: object[];
  title: string;
  crudLog: CrudHttp;
  logs: any;
  filtro: any;
  FechaInicio: '';
  FechaFin: '';
  constructor(private http: HttpClient) {
    this.loadSubMenu();
    this.crudLog = new CrudHttp(this.http);
    this.crudLog.methodGet = 'GetLogs';
    this.FechaInicio = '';
    this.FechaFin = '';

  }

  ngOnInit(): void {
    // this.getLogsList();
  }


  loadSubMenu() {
    var items = [
      {
        active: true,
        child: false,
        label: 'Logs',
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  getLogsList() {
    Utilerias.httpRequest(this.http, 'GetLogs', 'post', { fechaInicio: '', fechaFin: '' }).then(resp => {
      this.logs = resp;
      Utilerias.showLoader(false);
    })
  }

  formSearch(e: Event) {
    e.preventDefault();

    this.getLogsFiltro().then(resp => {
      this.logs = [];
      this.logs = resp;
      Utilerias.showLoader(false);
    })


  }


  getLogsFiltro() {
    return Utilerias.httpRequest(this.http, 'GetLogs', 'post', { fechaInicio: this.FechaInicio, fechaFin: this.FechaFin })
  }
}
